<div class="quote__content">
  <ng-content></ng-content>
</div>